import {SERVER} from "../constants";
import {MAP_URL} from "../constants/urls";
import {HttpClient} from "../utils/requests";
import {adviceMapperGetOneResponse} from "../panels/advice/adviceMapper";
import {blogMapperGetOneResponse} from "../panels/blog/blogMapper";
import {blogCategoryMapperGetOneResponse} from "../panels/blogCategory/blogCategoryMapper";
import {fixConfigId} from "../panels/config/configMapper";
import {userMapperGetOneResponse} from "../panels/user/userMapper";
import {forumCategoryMapperGetOneResponse} from "../panels/forumCategory/forumCategoryMapper";
import {forumMapperGetOneResponse} from "../panels/forum/forumMapper";
import {reportMapperGetOneResponse} from "../panels/report/reportMapper";
import {specialistCardMapperGetOneResponse} from "../panels/specialistCard/specialistCardMapper";
import {adminUsersMapperGetOneResponse} from "../panels/adminUsers/adminUsersMapper";
import {
  specialistCommentMapperGetOneResponse
} from "../panels/specialistComment/specialistCommentMapper";
import {invoiceMapperGetOneResponse} from "../panels/invoice/invoiceMapper";
import {adminLogHistoryMapperGetOneResponse} from "../panels/adminLogHistory/adminLogHistoryMapper";
import {userConversationMapperGetOneResponse} from "../panels/userConversation/userConversationMapper";
import {conversationAdMapperGetOneResponse} from "../panels/conversationAd/conversationAdMapper";
import {conversationMapperGetOneResponse} from "../panels/conversation/conversationMapper";
import {avatarMapperGetOneResponse} from "../panels/avatar/avatarMapper";
import {experimentMapperGetOneResponse} from "../panels/experiment/experimentMapper";
import {userVariantMapperGetOneResponse} from "../panels/userVariant/userVariantMapper";
import {variantMapperGetOneResponse} from "../panels/variant/variantMapper";
import {childWeekMapperGetOneResponse} from "../panels/childWeek/childWeekMapper";
import {marketLoginMapperGetOneResponse} from "../panels/marketLogin/marketLoginMapper";
import {welcomeModalMapperGetOneResponse} from "../panels/welcomeModal/welcomeModalMapper";
import {termsConditionMapperGetOneResponse} from "../panels/termsCondition/termsConditionMapper";
import {planMapperGetOneResponse} from "../panels/plan/planMapper";
import {planTypeMapperGetOneResponse} from "../panels/planType/planTypeMapper";
import {promotionMapperGetOneResponse} from "../panels/promotion/promotionMapper";
import {discountMapperGetOneResponse} from "../panels/discount/diacountMapper";
import {bulkDiscountMapperGetOneResponse} from "../panels/bulkDiscount/bulkDiacountMapper";
import {planFeaturesMapperGetOneResponse} from "../panels/planFeatures/planFeaturesMapper";
import {eventBannerMapperGetOneResponse} from "../panels/eventBanner/eventBannerMapper";
import {subscriptionMapperGetOneResponse} from "../panels/subscription/subscriptionMapper";

export function getOne(resource, params) {
  return HttpClient(`${SERVER}/${MAP_URL[resource]}/${params.id}`).then(({json}) => {
      if (resource === 'advice') {
        return adviceMapperGetOneResponse(json);
      } else if (resource === 'blogCategory') {
        return blogCategoryMapperGetOneResponse(json);
      } else if (resource === 'blog') {
        return blogMapperGetOneResponse(json);
      } else if (resource === 'config') {
        return fixConfigId(params, json);
      } else if (resource === 'user') {
        return userMapperGetOneResponse(params, json);
      } else if (resource === 'forumCategory') {
        return forumCategoryMapperGetOneResponse(json);
      } else if (resource === 'forum') {
        return forumMapperGetOneResponse(json);
      } else if (resource === 'report') {
        return reportMapperGetOneResponse(json);
      } else if (resource === 'specialistCard') {
        return specialistCardMapperGetOneResponse(json);
      } else if (resource === 'adminUsers') {
        return adminUsersMapperGetOneResponse(json);
      } else if (resource === 'specialistComment') {
        return specialistCommentMapperGetOneResponse(json);
      } else if (resource === 'invoice') {
        return invoiceMapperGetOneResponse(json);
      } else if (resource === 'adminLogHistory') {
        return adminLogHistoryMapperGetOneResponse(json);
      } else if (resource === "userConversation") {
        return userConversationMapperGetOneResponse(json);
      } else if (resource === "conversationAd") {
        return conversationAdMapperGetOneResponse(json);
      } else if (resource === "conversation") {
        return conversationMapperGetOneResponse(json);
      } else if (resource === "avatar") {
        return avatarMapperGetOneResponse(json);
      } else if (resource === "experiment") {
        return experimentMapperGetOneResponse(json);
      } else if (resource === "variant") {
        return variantMapperGetOneResponse(json);
      } else if (resource === "userVariant") {
        return userVariantMapperGetOneResponse(json);
      } else if (resource === "childWeek") {
        return childWeekMapperGetOneResponse(json);
      } else if (resource === "marketLogin") {
        return marketLoginMapperGetOneResponse(json);
      } else if (resource === "welcomeModal") {
          return welcomeModalMapperGetOneResponse(json);
      } else if (resource === "termsCondition") {
          return termsConditionMapperGetOneResponse(json);
      } else if (resource === "plan") {
          return planMapperGetOneResponse(json);
      } else if (resource === "planType") {
          return planTypeMapperGetOneResponse(json);
      } else if (resource === "promotion") {
          return promotionMapperGetOneResponse(json);
      } else if (resource === "discount") {
          return discountMapperGetOneResponse(json);
      } else if (resource === "bulkDiscount") {
          return bulkDiscountMapperGetOneResponse(json);
      } else if (resource === "planFeatures") {
          return planFeaturesMapperGetOneResponse(json);
      } else if (resource === "eventBanner") {
          return eventBannerMapperGetOneResponse(json);
      } else if (resource === "subscription") {
          return subscriptionMapperGetOneResponse(json);
      }

      return {data: {...json.result, id: json.result.objectId}};
    }
  );
}
